"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Match = function Match() {
  _classCallCheck(this, Match);

  _defineProperty(this, "home", void 0);

  _defineProperty(this, "away", void 0);
};

exports["default"] = Match;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9tYXRjaC50cyJdLCJuYW1lcyI6WyJNYXRjaCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7SUFBcUJBLEsiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBjbGFzcyBNYXRjaDxUPiB7XG4gIGhvbWU/OiBUO1xuICBhd2F5PzogVDtcbn1cbiJdfQ==